(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

  class StickyHeader extends HTMLElement {

    constructor() {

      super();

    }

    connectedCallback() {

      this.header = document.querySelector('.section-header');

      this.headerWrapper = this.header.querySelector('.header-wrapper') || this.header;

      this.stickyType = this.getAttribute('data-sticky-type') || 'none';

      this.headerIsAlwaysSticky =

        this.stickyType === 'always' || this.stickyType === 'reduce-logo-size';

      this.isHomePage = this.getAttribute('data-is-homepage') === 'true';

      this.headerBounds = {};

      this.setHeaderHeight();

      this.setAnnouncementBarOffset();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      window.addEventListener('resize', this.setAnnouncementBarOffset.bind(this));

      if (this.headerIsAlwaysSticky) {

        this.header.classList.add('shopify-section-header-sticky');

      }

      this.currentScrollTop = 0;

      this.preventReveal = false;

      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);

      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();

    }

    setHeaderHeight() {

      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);

    }

    setAnnouncementBarOffset() {

      const announcementBar = document.querySelector(

        '.announcement-bar, [data-announcement-bar], .utility-bar'

      );

      let offset = 0;

      if (announcementBar) {

        const computedPosition = window.getComputedStyle(announcementBar).position;

        if (computedPosition === 'sticky' || computedPosition === 'fixed') {

          offset = announcementBar.offsetHeight;

        }

      }

      document.documentElement.style.setProperty('--announcement-bar-offset', `${offset}px`);

    }

    disconnectedCallback() {

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      window.removeEventListener('scroll', this.onScrollHandler);

    }

    createObserver() {

      let observer = new IntersectionObserver((entries, observer) => {

        this.headerBounds = entries[0].intersectionRect;

        observer.disconnect();

      });

      observer.observe(this.header);

    }

    onScroll() {

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      requestAnimationFrame(() => {

        if (this.isHomePage) {

          const pastHero = scrollTop > window.innerHeight * 0.3;

          this.headerWrapper.classList.toggle('scrolled-past-hero', pastHero);

        }

        if (this.stickyType !== 'none') {

          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {

            this.header.classList.add('scrolled-past-header');

            if (!this.preventHide) this.hide();

          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {

            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {

              this.reveal();

            } else {

              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {

                this.preventReveal = false;

              }, 66);

              this.hide();

            }

          } else if (scrollTop <= this.headerBounds.top) {

            this.header.classList.remove('scrolled-past-header');

            this.reset();

          }

        }

        this.currentScrollTop = scrollTop;

      });

    }

    hide() {

      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');

      this.closeMenuDisclosure();

      this.closeSearchModal();

    }

    reveal() {

      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add('shopify-section-header-sticky', 'animate');

      this.header.classList.remove('shopify-section-header-hidden');

    }

    reset() {

      if (this.headerIsAlwaysSticky) return;

      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');

    }

    closeMenuDisclosure() {

      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');

      this.disclosures.forEach((disclosure) => disclosure.close());

    }

    closeSearchModal() {

      this.searchModal = this.searchModal || this.header.querySelector('details-modal');

      this.searchModal.close(false);

    }

  }

  customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();
})();
